export default "__VITE_ASSET__CK2t_1wfBPe87vAqL_l2Fg__"